import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { isConsentRequiredOnClient } from '../../../consent/clientScope'
import { readConsentState } from '../../../consent/deviceState'
import { canUsePurpose } from '../../../consent/types'
import type { ConsentPurpose } from '../../../consent/types'

export function consentContext() {
  const required = isConsentRequiredOnClient()
  const consent = readConsentState()

  function approvedChoice(purpose: ConsentPurpose): [] | [ConsentPurpose] {
    return canUsePurpose(consent, purpose) ? [purpose] : []
  }

  return comluxgroup.createConsent_1_0_0({
    required,
    approved_choices: required ? [
      ...approvedChoice('analytics'),
      ...approvedChoice('personalisation'),
      ...approvedChoice('experimentation'),
      ...approvedChoice('advertising'),
    ] : [],
  })
}
